'use client'

import { Typography } from '@acko/typography'
import styles from './page.module.css'

const imgQuote = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/quote_icon_db3e3990b8.svg'
const imgGeminiGeneratedImage = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/rekith_author_6665c6ad80.webp'

/* ─── Expert Tip Card ───────────────────────────────────────────────────────── */
const ExpertTipCard = () => (
  <div
    className={`${styles.dsCard} p-24 flex flex-col gap-24 items-start w-full`}
    data-bg="white"
    data-variant="outlined">
    <div className="flex flex-col gap-24 items-start w-full">
      <div className="w-48 h-48 shrink-0">
        <img alt="" className="w-full h-full object-contain" src={imgQuote} />
      </div>
      <div className="flex flex-col items-start w-full">
        <Typography variant="heading-lg" as="span" weight="semibold" color="primary" className={styles.expertTipText}>
          Expert tip: How do you select the right policy coverage?
        </Typography>
      </div>
      <Typography variant="body-md" color="primary" className="w-full">
        Selecting the right bike insurance requires understanding the fine details of policy coverage. Assess factors
        like your No Claim Bonus level, IDV (Insured Declared Value) selection, add-on choices, and exclusions to ensure
        the policy aligns with your specific needs and provides adequate protection.
      </Typography>
    </div>
    <div className="flex items-center w-full">
      <div className="flex flex-1 gap-12 items-center min-w-0">
        <div className="bg-white border-[1.5px] border-white overflow-hidden rounded-full shrink-0 w-48 h-48">
          <img alt="Rekhit Singh Kaushal" className="w-full h-full object-cover" src={imgGeminiGeneratedImage} />
        </div>
        <div className="flex flex-1 flex-col gap-4 items-start min-w-0">
          <Typography
            variant="body-md"
            weight="medium"
            color="primary"
            className="w-full text-[var(--font-body-sm-size)] leading-[var(--font-body-sm-line)] lg:text-[18px] lg:leading-[24px]">
            Rekhit Singh Kaushal
          </Typography>
          <Typography
            variant="body-md"
            color="secondary"
            className="whitespace-nowrap text-[var(--font-body-sm-size)] leading-[var(--font-body-sm-line)]">
            Senior Director, ACKO
          </Typography>
        </div>
      </div>
    </div>
  </div>
)

export const CoveragesSectionClient = () => (
  <div id="cover-options" className={`${styles.docSectionBlockGap} ${styles.sectionScrollTarget}`}>
    <ExpertTipCard />
  </div>
)
